export const BRAND = 'CenTrig'
